define('pages/spinner',["jquery", "appquery", "app"], function($, $$, App) {
    $$ = $$("spinner");

    return {
        init : function(data) {
            $$('#message').html(data.message || data);
            if(data.callback) {
                data.callback();
            }
        },
        footer : function(data) {
            return data.showFooter;
        }
    };
});
